export const DRAWER_MENU = {
    DRAWER_MENU_SET_SELECTED: "DRAWER_MENU_SET_SELECTED",
    DRAWER_MENU_CLEAR_SELECTED: "DRAWER_MENU_CLEAR_SELECTED",
  };
  